import React from 'react';
import { Video } from 'lucide-react';
import CrudManager from '../../components/admin/CrudManager';
import { getVideos, createVideo, updateVideo, deleteVideo } from '../../utils/api';

const fields = [
  { name: 'title', label: 'Video Title', type: 'text', required: true },
  { name: 'embedUrl', label: 'YouTube Embed URL', type: 'text', required: true, placeholder: 'https://www.youtube.com/embed/VIDEO_ID' },
  { name: 'category', label: 'Category', type: 'select', options: [
    { value: 'interview', label: 'Interview' },
    { value: 'promo', label: 'Promotion' },
    { value: 'event', label: 'Book Launch / Event' },
  ]},
];

export default function AdminVideos() {
  return (
    <CrudManager
      title="Videos"
      subtitle="Manage YouTube videos. Use embed URL format: https://www.youtube.com/embed/VIDEO_ID"
      fields={fields}
      fetchFn={getVideos}
      createFn={createVideo}
      updateFn={updateVideo}
      deleteFn={deleteVideo}
      emptyDefaults={{ category: 'interview' }}
      cardRenderer={(item) => (
        <div>
          <div className="aspect-video bg-slate-900">
            <iframe src={item.embedUrl} title={item.title} className="w-full h-full" allowFullScreen />
          </div>
          <div className="p-4">
            <h3 className="font-bold text-slate-900 flex items-center gap-2"><Video className="h-4 w-4 text-orange-500" /> {item.title}</h3>
          </div>
        </div>
      )}
    />
  );
}
